// extracted by mini-css-extract-plugin
module.exports = {"qItem":"FWvgI","more":"Kim5w"};